/**
 * customer.ts Common Script File
 *
 * @project Codendot
 * @company Codendot <https://codendot.com>
 * @author Yahya Al Omar <yahya.a@codendot.com>
 * @since Thursday, November 17, 2022, 11:15 AM GMT+2
 *
 */
import { log } from '@/lib/log';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { forEach } from 'lodash';


(() => {

    function main() {
        // initialize aos animation lib
        AOS.init({
            once: true,
            duration: 650, // values from 0 to 3000, with step 50ms
        });

        // Get the body element
        const body = document.querySelector('body');

        // Remove the "loader-init" class and add the "loaded" class to the body element
        body?.classList.remove('loader-init');
        body?.classList.add('loaded');

        // Bind a "beforeunload" event to the window object
        window.addEventListener('beforeunload', function () {
            // Remove the "loaded" class and add the "reload" class to the body element
            body?.classList.remove('loaded');
            body?.classList.add('reload');
        });



        const slideElements = document.querySelectorAll('.cnd-slide-background');
        const slideElementsImg = document.querySelectorAll('.cnd-slide-project');
        // const bannerContainer = document.querySelector('.cnd-banner-container') as HTMLElement;
        // const bannerSection = document.querySelector('.cnd-banner') as HTMLElement;


        let currentIndex = 0;

        function toggleActiveClass() {
            // Remove the "active" class from the current element
            slideElements[currentIndex].classList.remove('active');
            slideElementsImg[currentIndex].classList.remove('active');

            // Increment the index or loop back to the first element
            currentIndex = (currentIndex + 1) % slideElements.length;


            slideElements[currentIndex].classList.add('active');
            slideElementsImg[currentIndex].classList.add('active');

        }

        // Set an interval to toggle the class every 5 seconds
        if(slideElements.length>0){
            setInterval(toggleActiveClass, 5000);
        }

        // const projectsScrollElement = document.getElementById('projectsScroll') as HTMLElement
        // const offElt = document.querySelector('.offcanvas-top')

        // if (projectsScrollElement) {
        //     console.log('1')
        //     projectsScrollElement.addEventListener('click', () => {
        //         offElt?.close()
        //         console.log(offElt)
        //     });
        // }

        window.addEventListener('scroll', function () {
            var header = document.querySelector('.header-wrapper') as HTMLElement;
            var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollPosition > 10) {
                header.classList.add('active')
            } else {
                header.classList.remove('active')
            }
        });


        //intro script
        // const intro = document.querySelector(".intro") as HTMLElement;
        // const pointLight = document.querySelector(".point-light") as HTMLElement;
        // const wrapper = document.querySelector(".wrapper") as HTMLElement;
        // const services = document.querySelector(".services") as HTMLElement;

        // function circleIntersect(x0, y0, r0, x1, y1, r1) {
        //     return Math.hypot(x0 - x1, y0 - y1) <= r0 + r1;
        // }


        // if (intro && pointLight && wrapper) {
        //     window.addEventListener("mousemove", (event) => {
        //         const introBound = intro.getBoundingClientRect();
        //         const pointLightBound = pointLight.getBoundingClientRect();
        //         const servicesBound = services.getBoundingClientRect();
        //         const halfWidth = pointLightBound.width / 2;
        //         const halfHeight = pointLightBound.height / 2;

        //         let x = event.clientX - introBound.left;
        //         let y = event.clientY - introBound.top;

        //         if (halfWidth + x > introBound.width) {
        //             x = introBound.width - halfWidth;
        //         }
        //         if (halfHeight + y > introBound.height) {
        //             y = introBound.height - halfHeight;
        //         }
        //         if (x < halfWidth) {
        //             x = halfWidth;
        //         }
        //         if (y < halfHeight) {
        //             y = halfHeight;
        //         }

        //         if (
        //             circleIntersect(
        //                 servicesBound.left + servicesBound.width / 2,
        //                 servicesBound.top + servicesBound.height / 2,
        //                 servicesBound.width / 2,
        //                 pointLightBound.left + pointLightBound.width / 2,
        //                 pointLightBound.top + pointLightBound.height / 2,
        //                 pointLightBound.width / 2
        //             )
        //         ) {
        //             pointLight.style.opacity = "0";
        //         } else {
        //             pointLight.style.opacity = "1";
        //         }

        //         pointLight.style.left = `${x - halfWidth}px`;
        //         pointLight.style.top = `${y - halfHeight}px`;

        //         wrapper.style.left = `-${x - halfWidth}px`;
        //         wrapper.style.top = `-${y - halfHeight}px`;

        //     });

        //     intro.addEventListener("mouseover", () => {
        //         pointLight.style.display = "block";
        //     });

        //     intro.addEventListener("mouseout", () => {
        //         pointLight.style.display = "none";
        //     });

        // }


        // const createSvg = (words: string[], size: number, direction: string, opacity: number): void => {
        //     const text = words.join(`&nbsp;&nbsp;&nbsp;*&nbsp;&nbsp;&nbsp;`);
        //     const svg = /* html */ `
        //     <div class="svg-circle" style="--size:${size}px;--direction: ${direction}; --opacity: ${opacity}">
        //       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 500 500">
        //         <defs>
        //           <path d="M 250, 250 m -250, 0 a 250,250 0 1,0 500,0 a 250,250 0 1,0 -500,0" id="textcircle${size}" />
        //           <style>
        //             text {
        //               font-size: ${size / 20}px;
        //               font-family:"Poppins", sans-serif;
        //               font-weight: 700;
        //               text-transform: uppercase;
        //               letter-spacing: 3px;
        //             }
        //           </style>
        //         </defs>
        //         <text dx="0" dy="0" textpath="1600">
        //           <textPath xlink:href="#textcircle${size}">
        //             ${text}
        //           </textPath>
        //         </text>
        //       </svg>
        //     </div>
        //   `;

        //     const services = document.querySelector(".services") as HTMLElement;
        //     services.insertAdjacentHTML("beforeend", svg);
        // };

        // createSvg(["Digital Transformation", "e-commerce", "web solution"], 350, "alternate-reverse", 1);

        // createSvg(["API", "ChatGPT", "WordPress", 'APP', 'Hosting', 'CMS', 'SEO', 'SEM', 'SM'], 480, "alternate", 0.7);

        // const matrix = (interval = 200): void => {
        //     // Initialize the canvas
        //     const canvas = document.querySelector(".matrix") as HTMLCanvasElement;
        //     const ctx = canvas.getContext("2d");

        //     // Set the width and height of the canvas
        //     canvas.width = window.innerWidth;
        //     canvas.height = window.innerHeight;

        //     // Set up the letters
        //     const letters: string[] = ["0", "1"];

        //     // Set up the columns
        //     const fontSize = 30;
        //     const columns = Math.floor(canvas.width / fontSize);

        //     // Set up the drops
        //     const drops: number[] = [];
        //     for (let i = 0; i < columns; i++) {
        //         drops[i] = 1;
        //     }

        //     // Set up the draw function
        //     function draw() {
        //         if (ctx) {
        //             ctx.fillStyle = "rgba(0, 0, 0, .1)";
        //             ctx.fillRect(0, 0, canvas.width, canvas.height);

        //             for (let i = 0; i < drops.length; i++) {
        //                 const text = letters[Math.floor(Math.random() * letters.length)];
        //                 ctx.fillStyle = "#fff";
        //                 ctx.fillText(text, i * fontSize, drops[i] * fontSize);
        //                 drops[i]++;

        //                 if (drops[i] * fontSize > canvas.height && Math.random() > 0.95) {
        //                     drops[i] = 0;
        //                 }
        //             }
        //         }
        //     }

        //     // Loop the animation
        //     setInterval(draw, interval);
        // };

        // matrix(90);

        // const products = document.querySelectorAll(".product");

        // products.forEach(product => {
        //     product.addEventListener("mouseenter", function () {
        //         scaleProduct(this);
        //     });

        //     product.addEventListener("mouseleave", function () {
        //         resetProduct(this);
        //     });
        // });

        // function scaleProduct(element) {
        //     element.style.scale = "0.5";
        // }

        // function resetProduct(element) {
        //     element.style.scale = "0.6";
        // }

        const scrollDownButton = document.getElementById('scroll-down');
        const section1 = document.getElementById('section-1');
        const header = document.getElementById('header');

        if (scrollDownButton && section1 && header) {
            scrollDownButton.addEventListener('click', () => {
                const headerHeight = header.offsetHeight; // Get the height of the header
                const scrollOffset = section1.offsetTop - headerHeight; // Subtract the header height from the offset

                window.scrollTo({
                    top: scrollOffset,
                    behavior: 'smooth'
                });
            });
        }

    }

    document.addEventListener("readystatechange", async (event: any) => {
        if (event.target.readyState === 'complete') {
            main()
        }
    })


})()